<template>
  <app-panel class="panel-header__wrapper">
    <b-row
      class="panel-header"
      slot="panel-header"
      @click="setMetadata.hourRangeVisible = !setMetadata.hourRangeVisible"
    >
      <b-col>
        <label>
          {{ $t('sensors.regulation-sets.hour-range') }}
        </label>
        <info-badge
          v-if="isSetNumber1"
          :string-key="$t('messages.MI093.message')"
        />
      </b-col>
      <b-col cols="auto">
        <s-collapse-expand-button :value="setMetadata.hourRangeVisible" />
      </b-col>
    </b-row>
    <b-collapse
      id="hourRangeCollapse"
      slot="panel-body"
      :visible="setMetadata.hourRangeVisible"
    >
      <b-container fluid>
        <b-row class="justify-content-between">
          <b-col lg="auto">
            <b-row class="justify-content-end">
              <b-col
                class="panel-header__label"
                :class="{
                  'panel-header__label__disabled': isSetNumber1
                }"
                xs="12"
                lg="auto">
                  {{ $t('sensors.regulation-sets.operation-start-time') }}
              </b-col>
              <b-col
                class="text-center"
                xs="12"
                lg="auto">
                  <span v-if="isSetNumber1"> - </span>
                  <span v-else> {{ setMetadata.set.operationStartTime }} </span>
              </b-col>
            </b-row>
            <b-row class="justify-content-end">
              <b-col
                class="panel-header__label"
                :class="{
                  'panel-header__label__disabled': isSetNumber1
                }"
                xs="12"
                lg="auto"
              >
                {{ $t('sensors.regulation-sets.operation-end-time') }}
              </b-col>
              <b-col
                class="text-center"
                xs="12"
                lg="auto">
                  <span v-if="isSetNumber1"> -  </span>
                  <span v-else> {{ setMetadata.set.operationEndTime }} </span>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            xs="12"
            lg="7"
            class="hour-range-panel__weekdays"
          >
            <b-form-checkbox-group
              class="checkbox-group"
              :options="weekdaysOperationList"
              v-model="checkedFields"
            />
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>
  </app-panel>
</template>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.hour-range-panel
  &__weekdays
    ::v-deep .custom-control-inline
      display: flex
  +media-min-xl()
    &__weekdays
      column-count: 2
</style>

<script>
import { weekdaysValueList } from '@/data/dateTime';
import InfoBadge from '@/components/icon/InfoBadge';

export default {
  components: {
    InfoBadge,
  },
  props: {
    setMetadata: Object,
  },
  computed: {
    isSetNumber1() {
      return this.setMetadata.set.number === 1;
    },
    weekdaysOperationList() {
      return weekdaysValueList.map(weekdayValue => ({
        text: this.$t('sensors.regulation-sets.operation-on', {
          weekdayGenderOn: this.$t(`date-time.weekdays.${weekdayValue}.genderOn`),
          weekday: this.$t(`date-time.weekdays.${weekdayValue}.name`),
        }),
        value: weekdayValue,
        disabled: true,
      }));
    },
    checkedFields() {
      const { weekdaysOperation } = this.setMetadata.set;

      if (this.isSetNumber1) {
        return this.weekdaysOperationList.map(x => x.value);
      }

      return weekdaysOperation;
    },
  },
};
</script>
<style scoped lang="sass">
@import "src/styles/defaults/mobile-first"


.panel-header
  flex-wrap: nowrap
  &__wrapper
    page-break-inside: avoid
  &:hover
    cursor: pointer
  &__label
    font-weight: 600
    margin-bottom: 0.5rem
    text-align: right
    +media-max-md()
      text-align: center
    &__disabled
      color: var(--color-gray-medium-dark)
      font-weight: normal
</style>
